import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b0a7486"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dialog-footer"
};
const _hoisted_2 = ["src"];
import { ref, computed, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import { useRoute } from 'vue-router';
import { getWxClinicInfo, savaClinicInfo } from '@/api/tenant';
const Link = "<a style='color:blue;text-decoration:underline;' target='_blank' href='http://api.map.baidu.com/lbsapi/getpoint/index.html'>拾取坐标系统</a>(注意:经纬度之前用;隔开)";
export default {
  __name: 'WxInfo',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    clinicId: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props) {
    const store = useStore();
    const props = __props;
    const isVisible = useVModel(props);
    const form = ref({
      name: '',
      tel: '',
      address: '',
      coordinates: '',
      traffic: '',
      aboutUs: '',
      picture1: '',
      picture2: '',
      picture3: '',
      picture4: '',
      reservation: '',
      businessTime: ''
    });
    const headers = computed(() => {
      return {
        Authorization: 'Bearer ' + store.getters.token
      };
    });
    const actionUrl = computed(() => {
      return `api/yia/v1/wx_clinic/uploadClinicImage/${props.clinicId}`;
    });
    const fileList = ref([
      // {
      //   name: 'food.jpeg',
      //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
      // }
    ]);
    const handleRemove = (uploadFile, uploadFiles) => {
      fileList.value = uploadFiles;
    };
    const dialogImageUrl = ref('');
    const dialogVisible = ref(false);
    const handlePictureCardPreview = uploadFile => {
      dialogImageUrl.value = uploadFile.url;
      dialogVisible.value = true;
    };
    const getWxClinicInfoData = async () => {
      const res = await getWxClinicInfo(props.clinicId);
      if (res.id) {
        form.value = res;
      }
      for (let index = 0; index < 4; index++) {
        if (res[`picUrl${index + 1}`]) {
          fileList.value.push({
            url: res[`picUrl${index + 1}`]
          });
        }
      }
    };
    const onUploadSuccessHandler = val => {};
    const beforeUpload = rawFile => {
      if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif') {
        ElMessage.error('上传格式必须为jpeg, png, gif');
        return false;
      } else if (rawFile.size / 1024 / 1024 > 4) {
        ElMessage.error('上传大小不能大于3m');
        return false;
      }
      return true;
    };
    const route = useRoute();
    const onConfirmHandler = async () => {
      for (let index = 0; index < 4; index++) {
        var _fileList$value$index;
        if ((_fileList$value$index = fileList.value[index]) !== null && _fileList$value$index !== void 0 && _fileList$value$index.url) {
          var _fileList$value$index2;
          form.value[`picUrl${index + 1}`] = ((_fileList$value$index2 = fileList.value[index]) === null || _fileList$value$index2 === void 0 || (_fileList$value$index2 = _fileList$value$index2.response) === null || _fileList$value$index2 === void 0 ? void 0 : _fileList$value$index2.data) || fileList.value[index].url;
        } else {
          form.value[`picUrl${index + 1}`] = '';
        }
      }
      try {
        await savaClinicInfo({
          ...form.value,
          clinicId: props.clinicId,
          tenantId: route.params.tenantId
        });
        ElMessage({
          type: 'success',
          message: '操作成功'
        });
      } catch (error) {}
      isVisible.value = false;
    };
    watch(isVisible, val => {
      if (!val) {
        form.value = {
          name: '',
          tel: '',
          address: '',
          coordinates: '',
          traffic: '',
          aboutUs: '',
          picture1: '',
          picture2: '',
          picture3: '',
          picture4: '',
          reservation: '',
          businessTime: ''
        };
        fileList.value = [];
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_EditorCom = _resolveComponent("EditorCom");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        width: "60%",
        title: "微信消息显示",
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        "destroy-on-close": true,
        onOpen: getWxClinicInfoData,
        onClose: _cache[11] || (_cache[11] = $event => isVisible.value = false),
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onConfirmHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "诊所名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "客服热线"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.tel,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.tel = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "营业时间：",
            prop: "businessTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.businessTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.businessTime = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.address,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.address = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "地图坐标"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.coordinates,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.coordinates = $event)
            }, null, 8, ["modelValue"]), _createElementVNode("div", {
              innerHTML: Link
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "诊所预约提示消息"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              rows: 3,
              type: "textarea",
              modelValue: form.value.reservation,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.reservation = $event),
              maxlength: 100
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "交通路线"
          }, {
            default: _withCtx(() => [_createVNode(_component_EditorCom, {
              style: {
                "max-width": "100%"
              },
              modelValue: form.value.traffic,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.traffic = $event),
              width: "100%",
              height: "300"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "关于我们"
          }, {
            default: _withCtx(() => [_createVNode(_component_EditorCom, {
              style: {
                "max-width": "100%"
              },
              modelValue: form.value.aboutUs,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.aboutUs = $event),
              width: "100%",
              height: "300"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "图片"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              "file-list": fileList.value,
              "onUpdate:fileList": _cache[8] || (_cache[8] = $event => fileList.value = $event),
              action: actionUrl.value,
              "list-type": "picture-card",
              "on-remove": handleRemove,
              headers: headers.value,
              limit: 4,
              "on-preview": handlePictureCardPreview,
              "on-success": onUploadSuccessHandler,
              "before-upload": beforeUpload
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list", "action", "headers"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => dialogVisible.value = $event),
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          "w-full": "",
          src: dialogImageUrl.value,
          alt: "Preview Image"
        }, null, 8, _hoisted_2)]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};